// extracted by mini-css-extract-plugin
module.exports = {"RequestAccessButton":"Auth_RequestAccessButton__3atNp","ResetPasswordButton":"Auth_ResetPasswordButton__3IBIX"};